import {formatURL} from "./functions/util";

const DEV = false;
export const SERVER_URL = formatURL( ( DEV ) ? 'http://localhost/od_server/public/' :window.location.href );

if ( DEV )console.log( SERVER_URL );

export const PUBLIC_FOLDER = '';